import http, { API_CORE } from '../../http';

/**
 * Category Service for V2 API
 * All methods use /v2/categories endpoints
 */
export default function CategoryServiceV2() {
  const getAllCategories = async () => {
    const response = await http(API_CORE).get('/v2/categories/all');
    return response.data.categories;
  };

  const getCategories = async (params) => {
    const response = await http(API_CORE).get('/v2/categories', { params });
    return response.data;
  };

  const getCategoryById = async (id) => {
    const response = await http(API_CORE).get(`/v2/categories/${id}`);
    return response.data.category;
  };

  const createCategory = async (input) => {
    const response = await http(API_CORE).post('/v2/categories', input);
    return response.data.category;
  };

  const updateCategory = async (categoryId, input) => {
    const response = await http(API_CORE).patch(`/v2/categories/${categoryId}`, input);
    return response.data.category;
  };

  const deleteCategory = async (categoryId) => {
    const response = await http(API_CORE).delete(`/v2/categories/${categoryId}`);
    return response.data;
  };

  const reorderCategories = async (data) => {
    const response = await http(API_CORE).put('/v2/categories/reorder', data);
    return response.data;
  };

  return {
    getAllCategories,
    getCategories,
    getCategoryById,
    createCategory,
    updateCategory,
    deleteCategory,
    reorderCategories,
  };
}
